import apiClient from '../../../services/apiClient';

const getResponseData = (response) => {
  return response?.data?.data ?? response?.data ?? null;
};

export const getAuthErrorMessage = (
  error,
  fallbackMessage = 'Something went wrong. Please try again.',
) => {
  const responseData = error?.response?.data;

  if (typeof responseData?.message === 'string') {
    return responseData.message;
  }

  if (typeof responseData?.detail === 'string') {
    return responseData.detail;
  }

  if (typeof responseData?.error === 'string') {
    return responseData.error;
  }

  const errors = responseData?.errors;

  if (errors && typeof errors === 'object') {
    const firstError = Object.values(errors).flat()[0];

    if (typeof firstError === 'string') {
      return firstError;
    }

    if (firstError?.message) {
      return firstError.message;
    }
  }

  if (responseData && typeof responseData === 'object') {
    const ignoredKeys = [
      'success',
      'status',
      'status_code',
      'message',
      'data',
      'errors',
    ];

    const firstFieldError = Object.entries(responseData).find(
      ([key]) => !ignoredKeys.includes(key),
    );

    if (firstFieldError) {
      const [, value] = firstFieldError;

      if (Array.isArray(value) && value.length > 0) {
        return String(value[0]);
      }

      if (typeof value === 'string') {
        return value;
      }
    }
  }

  return fallbackMessage;
};

export const authApi = {
  login: async ({ email, password }) => {
    const response = await apiClient.post('/auth/login/', {
      email: email.trim().toLowerCase(),
      password,
    });

    return getResponseData(response);
  },

  forgotPassword: async (email) => {
    const response = await apiClient.post('/auth/forgot-password/', {
      email: email.trim().toLowerCase(),
    });

    return response?.data ?? null;
  },

  resetPassword: async ({
    uid,
    token,
    newPassword,
    confirmPassword,
  }) => {
    const response = await apiClient.post('/auth/reset-password/', {
      uid,
      token,
      new_password: newPassword,
      confirm_password: confirmPassword,
    });

    return response?.data ?? null;
  },
};

export default authApi;